import CrudActionSetBase from './CrudActionSetBase'

export class ReportRegistrationActionSet extends CrudActionSetBase('reportRegistration'){}
export default new ReportRegistrationActionSet()